import { Row, Tabs, Typography } from "antd"
import TabPane from "antd/lib/tabs/TabPane"
import React, { useState } from "react"
import { MsBots } from "./bots"
import { VerifDataBots } from "./VerifDataBots"
import { Visualisation } from "./Visualisation"
import { VerifyDataSirets } from "./VerifyDataSirets"
import MsGroupsButtonPlusModal from "../../cn-softaccess/components/ms/msGroupsButtonPlusModal"


const searchParams = new URLSearchParams(window.location.search);

const subTab = getTabNumerFromName(searchParams?.get("subtab") || undefined);
const parentTab = getTabNumerFromName(searchParams?.get("tab") || undefined);

function getTabNumerFromName(name: string | undefined) {
    if (!name) return "1";

    switch (name) {
        case "bot":
            return "1";
        case "validation":
            return "2";
        case "visualisation":
            return "3";
        case "siretization":
            return "2";
    }
}

console.log(parentTab, subTab);

export function MsBotsGeneral() {



    const [validationTabStep, setValidationTabStep] = useState(subTab);
    const [tab, setTab] = useState(parentTab);
    const [manualEnseigne, setManualEnseigne] = useState<string | undefined>(undefined);



    function triggerSetTab(tab: string, enseigne?: string) {
        if (tab == "2") {
            setValidationTabStep("2");
        }
        setTab(tab);
        setManualEnseigne(enseigne);
    }

    return (
        <>
            <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
                <Typography.Title level={1} style={{ margin: "0 20px 0 0" }}>Robots Multiscan</Typography.Title>
                <MsGroupsButtonPlusModal />
            </Row>
            <Tabs defaultActiveKey={parentTab} activeKey={tab} onChange={(key) => setTab(key)}>
                <TabPane tab="Lancement ou ajout de robots" key="1">
                    <MsBots setTab={triggerSetTab} />
                </TabPane>
                <TabPane tab="Validation des données" key="2">
                    <Tabs defaultActiveKey={subTab} activeKey={validationTabStep} onChange={(key) => setValidationTabStep(key)}>
                        <TabPane tab="Robots" key="1">
                            <VerifDataBots />
                        </TabPane>
                        <TabPane tab="Sirets" key="2">
                            <VerifyDataSirets manualEnseigne={manualEnseigne} />
                        </TabPane>
                    </Tabs>
                </TabPane>
                <TabPane tab="Visualisation" key="3">
                    <Visualisation />
                </TabPane>
            </Tabs>
        </>
    )
}